import {Component, EventEmitter, Input, Type, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {TitleToolbarDirective} from './title-toolbar.directive';
import {DateTimeHelpers} from '../../helpers/date-time.helpers';
import { DateRange } from '../date-range.component';
import { SharedModule } from '../../shared.module';

export interface PgTitleComponent {
  title: EventEmitter<string>;
}

export interface PgSubTitleComponent {
  subTitle: EventEmitter<string>;
}

export interface PgInnerHtmlSubComponent {
  innerHtml: EventEmitter<string>;
}

export enum PgDateRangeTitleEnum {
  persian,
  defaultTitle
}

export interface PgDateRangeTitleComponent {
  dateRangeSubTitle: EventEmitter<[DateRange, PgDateRangeTitleEnum]>;
}

export interface PgToolbarComponent {
  toolbarComponentType?: Type<any>;
  toolbarComponent: any;
}

@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, TitleToolbarDirective]
})
export class TitleBarComponent {

  @ViewChild(TitleToolbarDirective, { static: true }) toolbarHost?: TitleToolbarDirective;

  title?: string;
  subTitle?: string;
  innerHtml?: string;

  private _component: any;

  @Input() set component(value: any) {
    if (value) {
      this._component = value;
      this.routerOutletActivated(this._component);
    }
  }
  routerOutletActivated(component: any) {
    this.title = '';
    const titleComponent = component as PgTitleComponent;
    if (titleComponent.title) {
      titleComponent.title.subscribe(t => {
        if (t) {
          this.title = t;
        }
      });
    }

    this.subTitle = '';
    const subTitleComponent = component as PgSubTitleComponent;
    if (subTitleComponent.subTitle) {
      subTitleComponent.subTitle.subscribe(t => {
        if (t) {
          this.subTitle = t;
        }
      });
    }

    this.innerHtml = '';
    const innerHtmlComponent = component as PgInnerHtmlSubComponent;
    if (innerHtmlComponent.innerHtml) {
      innerHtmlComponent.innerHtml.subscribe(t => {
        if (t) {
          this.innerHtml = t;
        }
      });
    }

    this.subTitle = '';
    const subTitleDateRangeComponent = component as PgDateRangeTitleComponent;
    if (subTitleDateRangeComponent.dateRangeSubTitle) {
      subTitleDateRangeComponent.dateRangeSubTitle.subscribe(t => {
        if (t[1] === PgDateRangeTitleEnum.persian) {
          this.subTitle = `${t[0].startDate.toLocaleDateString('fa-IR')} - ` +
            `${t[0].endDate.toLocaleDateString('fa-IR')}`;
        } else {
          this.subTitle = `${DateTimeHelpers.formatLocalDate(t[0].startDate.getTime())} till ` +
            `${DateTimeHelpers.formatLocalDate(t[0].endDate.getTime())}`;
        }
      });
    }

    this.toolbarHost?.viewContainerRef.clear();
    const toolbarComponent = component as PgToolbarComponent;
    if (toolbarComponent.toolbarComponentType) {
      this.toolbarHost?.viewContainerRef.clear();
      // const componentFactory = this._componentFactoryResolver
      //   .resolveComponentFactory(toolbarComponent.toolbarComponentType);
      const componentRef = this.toolbarHost?.viewContainerRef.createComponent(toolbarComponent.toolbarComponentType);
      toolbarComponent.toolbarComponent = componentRef?.instance;
    }
  }
}
